

import { FC, useEffect, useState } from 'react';
import { displayFullDateAsVtTime, displayYearMonthAsVtTime } from '../../../utils/DateManagement';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { CourseEvent } from '../../../models/CourseEvent';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Table from 'react-bootstrap/esm/Table';
import { SurveyResponse } from '../../../models/SurveyResponse';
import SurveyResponseEndpoint from '../../../../api/endpoint/SurveyResponseEndpoint';
import { Document, Packer, Paragraph, TextRun, HeadingLevel, Table as DocTable, TableCell, TableRow, TableLayoutType, WidthType, AlignmentType } from "docx";
import { saveAs } from "file-saver";

interface SurveyProps {
    courseEvent: CourseEvent;
    show: boolean;
    onHide: () => void;
}

export const SurveyResponsesView: FC<SurveyProps> = ({courseEvent, show, onHide}) => {
    const [data, setData] = useState<SurveyResponse[] | undefined>(undefined);

    const getAverage = (question: number) => {
        const getQuestionTotals = (key: string) => {
            data?.forEach((response: SurveyResponse) => {
                total += response[key as keyof SurveyResponse];
                if(response[key as keyof SurveyResponse] !== 0) responsesLength++;
            });
        }

        if(data){
            var total: any = 0;
            var responsesLength = 0;
            switch(question){
                case 1:
                    getQuestionTotals('scaled_response_q1');
                    break;
                case 2:
                    getQuestionTotals('scaled_response_q2');
                    break;
                case 3:
                    getQuestionTotals('scaled_response_q3');
                    break;
                case 4:
                    getQuestionTotals('scaled_response_q4');
                    break;
                case 5:
                    getQuestionTotals('scaled_response_q5');
                    break;
                case 6:
                    getQuestionTotals('scaled_response_q6');
                    break;
                case 7:
                    getQuestionTotals('scaled_response_q7');
                    break;
                case 8:
                    getQuestionTotals('scaled_response_q8');
                    break;
                default:
                    console.error('Invalid question number');
            }
            return (total / responsesLength).toFixed(2);
        }
        else {
            return 'No data';
        }
    };

    const formatResponses = (question: number) => {
        const formatQuestionResponses = (key: string) => {
            data?.forEach((response: SurveyResponse) => {
                if(response[key as keyof SurveyResponse] !== 0) {
                    responses.push(response[key as keyof SurveyResponse].toString());
                }
            });
        }
        if(data){
            var responses: string[] = [];
            switch(question){
                case 1:
                    formatQuestionResponses('scaled_response_q1');
                    break;
                case 2:
                    formatQuestionResponses('scaled_response_q2');
                    break;
                case 3:
                    formatQuestionResponses('scaled_response_q3');
                    break;
                case 4:
                    formatQuestionResponses('scaled_response_q4');
                    break;
                case 5:
                    formatQuestionResponses('scaled_response_q5');
                    break;
                case 6:
                    formatQuestionResponses('scaled_response_q6');
                    break;
                case 7:
                    formatQuestionResponses('scaled_response_q7');
                    break;
                case 8:
                    formatQuestionResponses('scaled_response_q8');
                    break;
                default:
                    console.error('Invalid question number');
            }
            return responses.join(', ')
        }
        else{
            return 'No data';
        }
        
    };

    const getResponsePercent = (question: number, targetResponse: number): string => {
        const getQuestionTotals = (key: string) => {
            data?.forEach((response: SurveyResponse) => {
                if(response[key as keyof SurveyResponse] === targetResponse) numOfResponse++;
                if(response[key as keyof SurveyResponse] !== 0) responsesLength++;
            });
        }

        if(data){
            var numOfResponse: any = 0;
            var responsesLength = 0;
            switch(question){
                case 1:
                    getQuestionTotals('scaled_response_q1');
                    break;
                case 2:
                    getQuestionTotals('scaled_response_q2');
                    break;
                case 3:
                    getQuestionTotals('scaled_response_q3');
                    break;
                case 4:
                    getQuestionTotals('scaled_response_q4');
                    break;
                case 5:
                    getQuestionTotals('scaled_response_q5');
                    break;
                case 6:
                    getQuestionTotals('scaled_response_q6');
                    break;
                case 7:
                    getQuestionTotals('scaled_response_q7');
                    break;
                case 8:
                    getQuestionTotals('scaled_response_q8');
                    break;
                default:
                    console.error('Invalid question number');
            }
            return ((numOfResponse / responsesLength) * 100).toFixed(2) + "%";
        }
        else {
            return 'No data';
        }
    }

    const generateDownload = () => {
        const questionKey: Record<number, string> = {
            1: 'The class session was well-organized',
            2: 'The instructor presented the subject matter clearly',
            3: 'The class content was pertinent to my job',
            4: 'The presentation was clear and understandable',
            5: 'The instructor was well-prepared',
            6: 'The instructor encouraged questions',
            7: 'The course materials were useful',
            8: 'The class examples helped clarify the instruction',
            9: 'What did you like most about this training?',
            10: 'What did you like least about this training?',
            11: 'What, if anything, would you add, delete, or change about this class?',
            12: 'Do you have specific suggestions for improvement? If so, please elaborate.',
            13: 'Other Comments:'
        };

        const getTableRow = (question: number) => {
            
            const tableCells = [
                new TableCell({
                    children: [
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: questionKey[question],
                                    bold: true
                                })
                            ]
                        })
                    ]
                }),
            ];

            for(let i = 4; i > 0; i--) {
                tableCells.push(
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: getResponsePercent(question, i),
                                    })
                                ]
                            })
                        ]
                    }),
                )
            }

            return tableCells;
        };

        const table = new DocTable({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE
            },
            layout: TableLayoutType.AUTOFIT,
            margins: {
                top: 100,
                bottom: 100,
                left: 100,
                right: 100,
            },
            rows: [
                new TableRow({
                    children: [
                        new TableCell({
                            children:[new Paragraph({
                                children: []
                            })]
                        }),
                        new TableCell({
                            children: [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: "Strongly Agree",
                                            bold: true
                                        })
                                    ]
                                })
                            ]
                        }),
                        new TableCell({
                            children: [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: "Agree",
                                            bold: true
                                        })
                                    ]
                                })
                            ]
                        }),
                        new TableCell({
                            children: [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: "Disagree",
                                            bold: true
                                        })
                                    ]
                                })
                            ]
                        }),
                        new TableCell({
                            children: [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: "Strongly Disagree",
                                            bold: true
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }), 
                new TableRow({
                    children: getTableRow(1)
                }),
                new TableRow({
                    children: getTableRow(2)
                }),
                new TableRow({
                    children: getTableRow(3)
                }),
                new TableRow({
                    children: getTableRow(4)
                }),
                new TableRow({
                    children: getTableRow(5)
                }),
                new TableRow({
                    children: getTableRow(6)
                }),
                new TableRow({
                    children: getTableRow(7)
                }),
                new TableRow({
                    children: getTableRow(8)
                })
            ]
        });

        const getSections = (): any[] => {

            const getSAQHeading = (question: number) => {
                return new Paragraph({
                    spacing: {
                        before: 240,
                        after: 120
                    },
                    children: [
                        new TextRun({
                            text: questionKey[question],
                            bold: true,
                            
                        })
                    ]
                })
            };

            // question here goes by the short response number (1-5) not the number out of all questions (9-13)
            const getSAQResponses = (question: number): Paragraph[] => {
                const key = 'short_response_q' + question;
                const responses: Paragraph[] = [];
                if(data) {
                    for(let response of data) {
                        if(response[key as keyof SurveyResponse] !== ''){
                            responses.push(
                                new Paragraph({
                                    text: response[key as keyof SurveyResponse] as string,
                                    bullet: {level: 0}
                                })
                            );
                        }
                    }
                }

                return responses;
            };

            const children = [];

            children.push(
                new Paragraph({
                    text: 'VATTP Survey Summary and Compilation of Comments',
                    heading: HeadingLevel.HEADING_1,
                    alignment: AlignmentType.CENTER
                }),
                new Paragraph({
                    text: courseEvent.title,
                    heading: HeadingLevel.HEADING_2,
                    alignment: AlignmentType.CENTER
                }),
                new Paragraph({
                    text: courseEvent.location,
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.CENTER
                }),
                new Paragraph({
                    text: displayFullDateAsVtTime(courseEvent.start_date),
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.CENTER,
                    spacing: {
                        after: 360
                    },
                }),
                table,
                getSAQHeading(9),
                ...getSAQResponses(1),
                getSAQHeading(10),
                ...getSAQResponses(2),
                getSAQHeading(11),
                ...getSAQResponses(3),
                getSAQHeading(12),
                ...getSAQResponses(4),
                getSAQHeading(13),
                ...getSAQResponses(5),
            );

            return children;
        };

        const doc = new Document({
                styles: {
                    default: {
                        document: {
                            run: {
                                size: 22,
                                font: "Arial"
                            }
                        },
                    },
                },
            sections: [
                {
                    children: getSections()
                }
            ]
        });

        Packer.toBlob(doc).then((blob) => {
            saveAs(blob, `Survey_Summary_${courseEvent.location}_${displayYearMonthAsVtTime(courseEvent.start_date)}`);
        });
    }

    const getSurveys = async () => {
        const result = await SurveyResponseEndpoint.GetAllByEvent(courseEvent.course_event_id);

        
        if(!result || result.errors.length > 0) {
        }
        else {
            setData(result.data.map((row: any): SurveyResponse => ({
                survey_response_id: Number(row.survey_response_id),
                course_event_id: Number(row.course_event_id),
                scaled_response_q1: Number(row.scaled_response_q1),
                scaled_response_q2: Number(row.scaled_response_q2),
                scaled_response_q3: Number(row.scaled_response_q3),
                scaled_response_q4: Number(row.scaled_response_q4),
                scaled_response_q5: Number(row.scaled_response_q5),
                scaled_response_q6: Number(row.scaled_response_q6),
                scaled_response_q7: Number(row.scaled_response_q7),
                scaled_response_q8: Number(row.scaled_response_q8),
                short_response_q1: row.short_response_q1,
                short_response_q2: row.short_response_q2,
                short_response_q3: row.short_response_q3,
                short_response_q4: row.short_response_q4,
                short_response_q5: row.short_response_q5
            })));
        }
    };

    useEffect(() => {
        if(show) {
            getSurveys();
        }
    }, [show]);

    return (
        <Modal
            show={show}
            size="xl"
            aria-labelledby="surveys-title"
            centered
            onHide={onHide}
        >
            <Container>
                <Modal.Header closeButton>
                    <Container>
                        <Row>
                            <Modal.Title id="surveys-title">
                                {courseEvent.title}
                            </Modal.Title>
                            <h2 style={{fontSize: '1rem'}}>{displayFullDateAsVtTime(courseEvent.start_date)} Survey Responses</h2>
                        </Row>
                    </Container>
                </Modal.Header>
                <Modal.Body>
                    { data && data.length > 0 &&
                        <> 
                        <Container>
                            <Row className="justify-content-between">
                                <Col lg={9} md={12}>
                                    <div className="opacity-75">4 = Strongly Agree, 3 = Agree, 2 = Disagree, 1 = Strongly Disagree</div>
                                </Col>
                                <Col className="d-flex justify-content-end" lg={2}>
                                    <Button className="text-light" onClick={generateDownload}>Download</Button>
                                </Col>
                            </Row>
                        </Container>
                        <Table responsive className="table-stack-xs">
                            <thead>
                                <tr>
                                    <th>Question</th>
                                    <th>Average</th>
                                    <th>Responses</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Question</b></h6>
                                        The class session was well organized
                                    </td>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Average</b></h6>
                                        {getAverage(1)}
                                    </td>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Responses</b></h6>
                                        {formatResponses(1)}    
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Question</b></h6>
                                        The instructor presented the subject matter clearly
                                    </td>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Average</b></h6>
                                        {getAverage(2)}
                                    </td>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Responses</b></h6>
                                        {formatResponses(2)}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Question</b></h6>
                                        The class content was pertinent to my job
                                    </td>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Average</b></h6>
                                        {getAverage(3)}
                                    </td>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Responses</b></h6>
                                        {formatResponses(3)}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Question</b></h6>
                                        The presentation was clear and understandable
                                    </td>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Average</b></h6>
                                        {getAverage(4)}
                                    </td>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Responses</b></h6>
                                        {formatResponses(4)}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Question</b></h6>
                                        The instructor was well prepared
                                    </td>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Average</b></h6>
                                        {getAverage(5)}
                                    </td>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Responses</b></h6>
                                        {formatResponses(5)}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Question</b></h6>
                                        The instructor encouraged questions
                                    </td>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Average</b></h6>
                                        {getAverage(6)}
                                    </td>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Responses</b></h6>
                                        {formatResponses(6)}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Question</b></h6>
                                        The course materials were useful
                                    </td>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Average</b></h6>
                                        {getAverage(7)}
                                    </td>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Responses</b></h6>
                                        {formatResponses(7)}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Question</b></h6>
                                        The class examples helped clarify the instruction
                                    </td>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Average</b></h6>
                                        {getAverage(8)}
                                    </td>
                                    <td>
                                        <h6 className="td-xs-lbl d-sm-none"><b>Responses</b></h6>
                                        {formatResponses(8)}
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                        <h6 style={{marginTop:'1em'}}>What did you like most about this training?</h6>
                        <ul>
                            {data?.map((response, i: number) => {
                                if(response.short_response_q1 !== ''){
                                    return (
                                        
                                        <li key={`saq_${i}`}>{response.short_response_q1}</li>
                                    );
                                }
                            })}
                            
                        </ul>
                        {(data?.map((response) => response.short_response_q1).length == 0 ||
                            data?.map((response) => response.short_response_q1).every((val) => val === '')
                        ) &&
                            <div className="text-secondary" style={{fontStyle: 'italic'}}>No responses provided.</div>
                        }

                        <hr/>

                        <h6>What did you like least about this training?</h6>
                        <ul>
                            {data?.map((response, i: number) => {
                                if(response.short_response_q2 !== ''){
                                    return (
                                        <li key={`saq_${i}`}>{response.short_response_q2}</li>
                                    );
                                }
                            })}
                        </ul>

                        {(data?.map((response) => response.short_response_q2).length == 0 ||
                            data?.map((response) => response.short_response_q2).every((val) => val === '')
                        ) &&
                            <div className="text-secondary" style={{fontStyle: 'italic'}}>No responses provided.</div>
                        }

                        <hr />

                        <h6>What, if anything, would you add, delete, or change about this class?</h6>
                        <ul>
                            {data?.map((response, i: number) => {
                                if(response.short_response_q3 !== ''){
                                    return (
                                        <li key={`saq_${i}`}>{response.short_response_q3}</li>
                                    );
                                }
                            })}
                        </ul>

                        {(data?.map((response) => response.short_response_q3).length == 0 ||
                            data?.map((response) => response.short_response_q3).every((val) => val === '')
                        ) &&
                            <div className="text-secondary" style={{fontStyle: 'italic'}}>No responses provided.</div>
                        }

                        <hr/>

                        <h6>Do you have specific suggestions for improvement? If so, please elaborate.</h6>
                        <ul>
                            {data?.map((response, i: number) => {
                                if(response.short_response_q4 !== ''){
                                    return (
                                        <li key={`saq_${i}`}>{response.short_response_q4}</li>
                                );
                                }
                            })}
                        </ul>

                        {(data?.map((response) => response.short_response_q4).length == 0 ||
                            data?.map((response) => response.short_response_q4).every((val) => val === '')
                        ) &&
                            <div className="text-secondary" style={{fontStyle: 'italic'}}>No responses provided.</div>
                        }

                        <hr/>

                        <h6>Other Comments:</h6>
                        <ul>
                            {data?.map((response, i: number) => {
                                if(response.short_response_q5 !== ''){
                                    return (
                                        <li key={`saq_${i}`}>{response.short_response_q5}</li>
                                    );
                                }
                            })}
                        </ul>

                        {(data?.map((response) => response.short_response_q5).length == 0 ||
                            data?.map((response) => response.short_response_q5).every((val) => val === '')
                        ) &&
                            <div className="text-secondary" style={{fontStyle: 'italic'}}>No responses provided.</div>
                        }
                        </>
                    }
                    { !data || data.length === 0 &&
                        <div>No surveys available for selected course.</div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>Close</Button>
                </Modal.Footer>
            </Container>
        </Modal>
    )
}